import * as React from 'react';

import { cn } from '@/lib/utils';

/**
 * TableToolbar — the row between PageHeader and DataTable.
 * Left side: search + filters (children). Right side: secondary actions.
 * Wraps on mobile; keeps every list page's controls in the same place.
 */
export interface TableToolbarProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Right-aligned secondary actions (export, view toggles, …). */
  actions?: React.ReactNode;
}

const TableToolbar = React.forwardRef<HTMLDivElement, TableToolbarProps>(
  ({ children, actions, className, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex flex-wrap items-center justify-between gap-2', className)}
      {...props}
    >
      <div className="flex flex-1 flex-wrap items-center gap-2">{children}</div>
      {actions ? <div className="flex flex-wrap items-center gap-2">{actions}</div> : null}
    </div>
  ),
);
TableToolbar.displayName = 'TableToolbar';

export { TableToolbar };
